'use strict';

var createRenderState = require('../../html/utils/create-render-state.cjs');

const createSvgRenderState = () => ({
    ...createRenderState.createHtmlRenderState(),
    attrs: {},
});

exports.createSvgRenderState = createSvgRenderState;
//# sourceMappingURL=create-render-state.cjs.map
